import React from "react";
import { Column } from "@amzn/meridian";
import { useAppSelector } from "src/store/store";
import TemplateDisplayCard from "src/components/pages/templates/templateDisplayCard";

const Home = () => {
  const { inspectionTemplates } = useAppSelector((state) => state.data);
  return (
    <Column>
      {inspectionTemplates.map((template) => (
        <TemplateDisplayCard
          key={template.templateId}
          inspectionTemplate={template}
        />
      ))}
    </Column>
  );
};

export default Home;
